import { DashboardDataType as DashboardType } from 'model/dashboardDataType.model';

export const DashboardDataType = {
    pieCard: 'pie-card' as DashboardType,
    lineChart: 'line-chart' as DashboardType,
    reservationAndOccupationCard: 'reservation-and-occupation-card' as DashboardType,
}